import React, { useEffect, useState } from "react";
import Data from "../../components/dropdown/matematikUniteler/All.json";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Container } from "../../style/global/styledComponents/Containers";

function SearchResults() {
  const [results, setResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const searchTermFromURL = params.get("search");
    setSearchTerm(searchTermFromURL || "");

    if (!searchTermFromURL) {
      setResults([]);
      return;
    }

    const filteredItems = Data.filter((item) =>
      item.title.toLowerCase().includes(searchTermFromURL.toLowerCase())
    );
    setResults(filteredItems);
  }, [params]);

  const handleItemClick = (url) => {
    navigate(url); // ✅ SPA yönlendirme
  };

  return (
    <Container>
      <Main>
        <h1>Arama Sonuçları</h1>
        {searchTerm && results.length === 0 && (
          <NoResult>"{searchTerm}" için sonuç bulunamadı.</NoResult>
        )}
        <ResultsGrid>
          {results.map((item) => (
            <ResultCard key={item.id} onClick={() => handleItemClick(item.url)}>
              <CardTitle>{item.title}</CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </ResultCard>
          ))}
        </ResultsGrid>
      </Main>
    </Container>
  );
}

const Main = styled.div`
  flex: 1;
  width: 100%;
  margin: 2rem auto;
  min-height: 100vh;
  max-width: var(--main-width);

  h1 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
    color: var(--main-color);
  }
`;

const NoResult = styled.p`
  text-align: center;
  color: gray;
  font-size: 1.1rem;
  margin-top: 2rem;
`;

const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

const ResultCard = styled.div`
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: var(--main-color);
  }
`;

const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color: var(--main-color);
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: #555;
  line-height: 1.5;
`;

export default SearchResults;
